// JavaScript Document

/* category List */
function cateimgli(callback,append){
var cateimglist = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/' + callback + '.jsonp',
        type:"GET",
        dataType:"jsonp",
	jsonpCallback: callback,
        error:function() {
//            alert("ロード失敗");
        },
        success: function(json){
	 	var len = json.length;
    		for(var i=0; i < len; i++){
				if(json[i].url != ""){
					cateimglist = '<li><a href="' + json[i].url_o + '" target="_top"><img class="thum" src="' + json[i].img + '">' + json[i].name + '</a></li>';
				} else {
					cateimglist = '';
				}
   				$(append).append(cateimglist);
   			}
		}
    })
};

